/* Enhancement only: no WebGL, dependencies, motion permission, or scroll hijacking. */
(function () {
  var stage = document.querySelector('.visual-stage');
  var hero = document.querySelector('.atelier-hero');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var frame = 0;
  function reset() {
    cancelAnimationFrame(frame);
    stage.style.setProperty('--tilt-x', '0deg');
    stage.style.setProperty('--tilt-y', '0deg');
    stage.style.setProperty('--light-x', '50%');
    stage.style.setProperty('--light-y', '38%');
    hero.style.setProperty('--hero-x', '0px');
    hero.style.setProperty('--hero-y', '0px');
  }
  stage.addEventListener('pointermove', function (event) {
    if (reduce.matches || !fine.matches) return;
    var rect = stage.getBoundingClientRect();
    var x = (event.clientX - rect.left) / rect.width;
    var y = (event.clientY - rect.top) / rect.height;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(function () {
      stage.style.setProperty('--tilt-x', ((.5 - y) * 5) + 'deg');
      stage.style.setProperty('--tilt-y', ((x - .5) * 7) + 'deg');
      stage.style.setProperty('--light-x', (x * 100) + '%');
      stage.style.setProperty('--light-y', (y * 100) + '%');
    });
  }, {passive:true});
  stage.addEventListener('pointerleave', function () { cancelAnimationFrame(frame); reset(); });
  hero.addEventListener('pointermove', function (event) {
    if (reduce.matches || !fine.matches) return;
    var rect = hero.getBoundingClientRect();
    hero.style.setProperty('--hero-x', ((event.clientX - rect.left) / rect.width - .5) * 9 + 'px');
    hero.style.setProperty('--hero-y', ((event.clientY - rect.top) / rect.height - .5) * 7 + 'px');
  }, {passive:true});
  hero.addEventListener('pointerleave', reset);
  [reduce, fine].forEach(function (query) {
    if (query.addEventListener) query.addEventListener('change', reset);
    else if (query.addListener) query.addListener(reset);
  });
}());
